import { render } from "./DrugstoreCommonManager.vue?vue&type=template&id=4ac24f16"
import script from "./DrugstoreCommonManager.vue?vue&type=script&lang=js"
export * from "./DrugstoreCommonManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__